export const TypesOfModes = {
  'Math': 'Math',
  'MultiPlayer': 'MultiPlayer',
  'LiveClass': 'LiveClass',
  'Printables': 'Printables'
}